export const LANGUAGES_LIST = [
  { value: 'English', label: 'English' },
  { value: 'Russian', label: 'Russian' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Korean', label: 'Korean' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Turkish', label: 'Turkish' },
  { value: 'Dutch', label: 'Dutch' },
  { value: 'Swedish', label: 'Swedish' },
  { value: 'Norwegian', label: 'Norwegian' },
  { value: 'Finnish', label: 'Finnish' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Polish', label: 'Polish' },
  { value: 'Czech', label: 'Czech' },
  { value: 'Hungarian', label: 'Hungarian' },
  { value: 'Romanian', label: 'Romanian' },
  { value: 'Ukrainian', label: 'Ukrainian' },
  { value: 'Belarusian', label: 'Belarusian' },
  { value: 'Serbian', label: 'Serbian' },
  { value: 'Croatian', label: 'Croatian' },
  { value: 'Slovak', label: 'Slovak' },
  { value: 'Bulgarian', label: 'Bulgarian' },
  { value: 'Lithuanian', label: 'Lithuanian' },
  { value: 'Latvian', label: 'Latvian' },
  { value: 'Estonian', label: 'Estonian' },
  { value: 'Georgian', label: 'Georgian' },
  { value: 'Armenian', label: 'Armenian' },
  { value: 'Azerbaijani', label: 'Azerbaijani' },
  { value: 'Kazakh', label: 'Kazakh' },
  { value: 'Uzbek', label: 'Uzbek' },
  { value: 'Tajik', label: 'Tajik' },
  { value: 'Turkmen', label: 'Turkmen' },
  { value: 'Kyrgyz', label: 'Kyrgyz' },
  { value: 'Mongolian', label: 'Mongolian' },
  { value: 'Vietnamese', label: 'Vietnamese' },
  { value: 'Thai', label: 'Thai' },
  { value: 'Indonesian', label: 'Indonesian' },
  { value: 'Malay', label: 'Malay' },
  { value: 'Filipino', label: 'Filipino' },
  { value: 'Persian', label: 'Persian' },
  { value: 'Pashto', label: 'Pashto' },
  { value: 'Sinhalese', label: 'Sinhalese' },
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Nepali', label: 'Nepali' },
  { value: 'Burmese', label: 'Burmese' },
  { value: 'Swahili', label: 'Swahili' },
  { value: 'Zulu', label: 'Zulu' },
  { value: 'Hebrew', label: 'Hebrew' },
  { value: 'Irish', label: 'Irish' },
  { value: 'Gaelic', label: 'Gaelic' },
  { value: 'Icelandic', label: 'Icelandic' }
];
